import React, { useEffect, useState } from 'react'
import "./HeaderCarousal.scss";
import { Carousel } from 'react-responsive-carousel';
import "react-responsive-carousel/lib/styles/carousel.min.css";

import AssuredProtectionImage from '../../public/images/sip-select/assured_protection.png'

// Import Education Images
import EducationBanner1 from '../../public/images/sip-select/bannerCarousal/education/education_banner_1.png';
import EducationBanner2 from '../../public/images/sip-select/bannerCarousal/education/education_banner_2.png';
import EducationBanner3 from '../../public/images/sip-select/bannerCarousal/education/education_banner_3.png';
import EducationBanner4 from '../../public/images/sip-select/bannerCarousal/education/education_banner_4.png';

// Import Animal Images
import AnimalsBanner1 from '../../public/images/sip-select/bannerCarousal/animals/animals_banner_1.png';
import AnimalsBanner2 from '../../public/images/sip-select/bannerCarousal/animals/animals_banner_2.png';
import AnimalsBanner3 from '../../public/images/sip-select/bannerCarousal/animals/animals_banner_3.png';
import AnimalsBanner4 from '../../public/images/sip-select/bannerCarousal/animals/animals_banner_4.png';

// Import Women Images
import WomenGirlsBanner1 from '../../public/images/sip-select/bannerCarousal/women_girls/women_girls_banner_1.png';
import WomenGirlsBanner2 from '../../public/images/sip-select/bannerCarousal/women_girls/women_girls_banner_2.png';
import WomenGirlsBanner3 from '../../public/images/sip-select/bannerCarousal/women_girls/women_girls_banner_3.png';
import WomenGirlsBanner4 from '../../public/images/sip-select/bannerCarousal/women_girls/women_girls_banner_4.png';

// Import Food Images
import FoodHungerBanner1 from '../../public/images/sip-select/bannerCarousal/food_hunger/food_hunger_banner_1.png';
import FoodHungerBanner2 from '../../public/images/sip-select/bannerCarousal/food_hunger/food_hunger_banner_2.png';
import FoodHungerBanner3 from '../../public/images/sip-select/bannerCarousal/food_hunger/food_hunger_banner_3.png';
import FoodHungerBanner4 from '../../public/images/sip-select/bannerCarousal/food_hunger/food_hunger_banner_4.png';

// Import Food Images
import MedicalBanner1 from '../../public/images/sip-select/bannerCarousal/medical/medical_banner_1.png';
import MedicalBanner2 from '../../public/images/sip-select/bannerCarousal/medical/medical_banner_2.png';
import MedicalBanner3 from '../../public/images/sip-select/bannerCarousal/medical/medical_banner_3.png';
import MedicalBanner4 from '../../public/images/sip-select/bannerCarousal/medical/medical_banner_4.png';

// Import Food Images
import WidowBanner1 from '../../public/images/sip-select/bannerCarousal/widow/widow_banner_1.png';
import WidowBanner2 from '../../public/images/sip-select/bannerCarousal/widow/widow_banner_2.png';
import WidowBanner3 from '../../public/images/sip-select/bannerCarousal/widow/widow_banner_3.png';
import WidowBanner4 from '../../public/images/sip-select/bannerCarousal/widow/widow_banner_4.png';

// Import Food Images
import ElderyBanner1 from '../../public/images/sip-select/bannerCarousal/eldery/eldery_banner_1.png';
import ElderyBanner2 from '../../public/images/sip-select/bannerCarousal/eldery/eldery_banner_2.png';
import ElderyBanner3 from '../../public/images/sip-select/bannerCarousal/eldery/eldery_banner_3.png';
import ElderyBanner4 from '../../public/images/sip-select/bannerCarousal/eldery/eldery_banner_4.png';

// Import Food Images
import AcidVictimsBanner1 from '../../public/images/sip-select/bannerCarousal/acid_victims/acid_victims_banner_1.png';
import AcidVictimsBanner2 from '../../public/images/sip-select/bannerCarousal/acid_victims/acid_victims_banner_2.png';
import AcidVictimsBanner3 from '../../public/images/sip-select/bannerCarousal/acid_victims/acid_victims_banner_3.png';
import AcidVictimsBanner4 from '../../public/images/sip-select/bannerCarousal/acid_victims/acid_victims_banner_4.png';
import { getCurrencySymbol } from '../../../services/helperFunctions';
import { SIP_STATUS } from '../SipDetailsV2/SipDetailV2';
import dayjs from 'dayjs';

// Image data configuration for different causes
const causeImages = {
	education: [
		{ path: EducationBanner1, alt: 'Banner_image' },
		{ path: EducationBanner2, alt: 'Banner_image' },
		{ path: EducationBanner3, alt: 'Banner_image' },
		{ path: EducationBanner4, alt: 'Banner_image' },
	],
	animals: [
		{ path: AnimalsBanner1, alt: 'Banner_image' },
		{ path: AnimalsBanner2, alt: 'Banner_image' },
		{ path: AnimalsBanner3, alt: 'Banner_image' },
		{ path: AnimalsBanner4, alt: 'Banner_image' },
	],
	women_girls: [
		{ path: WomenGirlsBanner1, alt: 'Banner_image' },
		{ path: WomenGirlsBanner2, alt: 'Banner_image' },
		{ path: WomenGirlsBanner3, alt: 'Banner_image' },
		{ path: WomenGirlsBanner4, alt: 'Banner_image' },
	],
	food_hunger: [
		{ path: FoodHungerBanner1, alt: 'Banner_image' },
		{ path: FoodHungerBanner2, alt: 'Banner_image' },
		{ path: FoodHungerBanner3, alt: 'Banner_image' },
		{ path: FoodHungerBanner4, alt: 'Banner_image' },
	],
	medical: [
		{ path: MedicalBanner1, alt: 'Banner_image' },
		{ path: MedicalBanner2, alt: 'Banner_image' },
		{ path: MedicalBanner3, alt: 'Banner_image' },
		{ path: MedicalBanner4, alt: 'Banner_image' },
	],
	widow: [
		{ path: WidowBanner1, alt: 'Banner_image' },
		{ path: WidowBanner2, alt: 'Banner_image' },
		{ path: WidowBanner3, alt: 'Banner_image' },
		{ path: WidowBanner4, alt: 'Banner_image' },
	],
	elderly: [
		{ path: ElderyBanner1, alt: 'Banner_image' },
		{ path: ElderyBanner2, alt: 'Banner_image' },
		{ path: ElderyBanner3, alt: 'Banner_image' },
		{ path: ElderyBanner4, alt: 'Banner_image' },
	],
	acid_victims: [
		{ path: AcidVictimsBanner1, alt: 'Banner_image' },
		{ path: AcidVictimsBanner2, alt: 'Banner_image' },
		{ path: AcidVictimsBanner3, alt: 'Banner_image' },
		{ path: AcidVictimsBanner4, alt: 'Banner_image' },
	]
};

//default stats
const stats = [
	{ value: '6301', label: 'Lives saved' },
	{ value: '2.3CR', label: 'Money raised' },
	{ value: '3301', label: 'Donors' }
];

const HeaderCarousal = ({ campaign_cause = 'education', summary, sipStatus, latestOrder, count }) => {
	const [impactStats, setImpactStats] = useState(stats);
	const [images, setImages] = useState([]);

	useEffect(() => {
		// Update component state when cause changes
		if (typeof causeImages[campaign_cause] !== "undefined") {
			setImages(causeImages[campaign_cause]);
		} else {
			console.warn(`Images for campaign_cause "${campaign_cause}" not found`);
			// Fallback to education if selected campaign_cause doesn't exist
			setImages(causeImages["education"]);
		}
	}, [campaign_cause, summary]);

	useEffect(() => {
		setImpactStats(stats)
		if (sipStatus !== SIP_STATUS.NEW) {
			setImpactStats([
				{ label: 'Lives impacted', value: summary?.funds },
				{ label: 'Do good days', value: daysFromCreatedDate(latestOrder?.creation_time) },
				{ label: 'Your tax saving', value: getCurrencySymbol("inr") + summary.tax_amount },
			]);
		} else {
			setImpactStats([
				{ label: 'Lives impacted', value: count?.lives_saved },
				{ label: 'Money raised', value: getCurrencySymbol("inr") + count.raised_so_far },
				{ label: 'Donors', value: count.active_donors },
			]);
		}
	}, [campaign_cause, latestOrder, summary, sipStatus, count]);

	const daysFromCreatedDate = (createDateStr) => {
		if (!createDateStr) return "";
		const createDate = dayjs(createDateStr);
		const today = dayjs();
		const days = today.diff(createDate, 'day');
		return days;
	}

	return (
		<>
			<div className="stats-card-container">
				<Carousel
					showArrows={true}
					showStatus={false}
					showThumbs={false}
					showIndicators={true}
					infiniteLoop={true}
					autoPlay={true}
					interval={3000}
					stopOnHover={true}
					swipeable={true}
					emulateTouch={false}
					dynamicHeight={false}
					transitionTime={300}
					preventMovementUntilSwipeScrollTolerance={true}
					swipeScrollTolerance={30}
					className="stats-carousel"
					renderIndicator={(onClickHandler, isSelected, index, label) => (
						<li
							className={`custom-indicator ${isSelected ? 'selected' : ''}`}
							onClick={(e) => {
								e.preventDefault();
								onClickHandler(e);
							}}
							onKeyDown={(e) => {
								if (e.key === 'Enter' || e.key === ' ') {
									e.preventDefault();
									onClickHandler(e);
								}
							}}
							key={`indicator-${index}`}
							role="button"
							tabIndex={0}
							aria-label={`Slide ${index + 1}`}
						/>
					)}
				>
					{images.map((img, index) => (
						<div className='image-section' key={`slide-${index}`}>
							<img
								src={img?.path}
								alt="Children in school uniforms"
								draggable="false"
							/>
							<div className='image-overlay'></div>
							<span className='assured-badge'>
								<img
									src={AssuredProtectionImage}
									alt="assured_protection_logo"
									draggable="false"
								/>
							</span>
						</div>
					))}
				</Carousel>

				{/* Stats Section */}
				<div className="stats-section">
					{impactStats.map((stat, index) => (
						<React.Fragment key={index}>
							<div className="stat-item">
								<span className="stat-value">{stat.value}</span>
								<span className="stat-label">{stat.label}</span>
							</div>
							{index < impactStats.length - 1 && <div className="stat-divider" />}
						</React.Fragment>
					))}
				</div>
			</div>
		</>
	)
}

export default HeaderCarousal;
